import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FormControlLabel } from "@mui/material";
import {
  Button,
  Col,
  Form,
  Row,
  Stack,
  Container,
  Card,
} from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Formik } from "formik";
import { nameBasedRoutes } from "../../router/public";
import { nameBasedProtectedRoutes } from "../../router/protected";
import FormHelperText from "@mui/material/FormHelperText";
import InputText from "../../components/common/InputText";
import InputSelect from "../../components/common/InputSelect";
import InputSelectMultiple from "../../components/common/InputSelectMultiple";
import InputTextArea from "../../components/common/TextArea";
import InputDatePicker from "../../components/common/InputDatePicker";
import storage from "../../helpers/storage";
import { getUserDetails, getMachineList } from "../../services/userService";
import { inspectionRequest } from "../../services/inspectionRequest";
import { getStateList } from "../../services/authService";
import Loader from "../../components/common/Loader";
import {
  InspectionRequestSchema,
  AddMachineSchema,
} from "../../validations/InspectionRequest";
import plusIcon from "../../assets/images/plus-solid.svg";
import PlusBlue from "../../assets/images/plus-blue.svg";
import DeleteIcon from "../../assets/images/Delete-icon.svg";
import GooglePinIcon from "../../assets/images/google-pin-icon.svg";
import { withScriptjs, withGoogleMap, Marker } from "react-google-maps";
import DatePicker from "react-datepicker";
import Modal from "react-bootstrap/Modal";
import "react-datepicker/dist/react-datepicker.css";

import MatDatePicker from "../../components/common/MatDatePicker";
import moment from "moment";
import { toast } from "react-toastify";
import { MESSAGES } from "../../constants/messages";
import EmailIcon  from "../../assets/images/email.svg";
import PhoneIcon from "../../assets/images/contact-phone.svg"


export const Contact = () => {
  let initialValues = {
    project_name: "",
    no_machine: "",
    job_contact: "",
    company_name: "",
    po_no: "",
    ordered_by: "",
    inspection_datetime: "",
    machine_inspect: [],
    job_location: "",
    job_location_address: "",
    job_location_city: "",
    job_location_state: "",
    job_location_zip_code: "",
    job_location_comment: "",

    decal_name: "",
    decal_email: "",
    decal_address: "",
    decal_city: "",
    decal_state: "",
    decal_zip_code: "",

    Status: false,
  };
  const handleSubmit = async (values: any, actions: any) => {
    

      let formData = {
        inspection_date: "22",
        inspection_time: "",
        job_contact: values.job_contact,
        inspection_date_time: "",
        job_location_address: values.job_location_address,
        job_location_city: values.job_location_city,
        job_location_comment: values.job_location_comment,
        job_location_state: "jgj",
        job_location_zip_code: values.job_location_zip_code,
        
        no_machine: values.no_machine,
        ordered_by: values.ordered_by,
        po_no: values.po_no,
        project_name: values.project_name,
        
      };

      
    
  };

  return (
    <>
      <section className="profile-main pt-4 dashboard-content faq-content">
        <Container className="">
          <Row>
            <Col md={6} lg={6}>
              <h1 className="fs-30 fw-bold mb-1 mt-2">Contact Us</h1>
              <p className="fs-15 ">Submit your questions or comments below.</p>
            </Col>
            <Col md={6} lg={6} className="align-items-center col-lg-6 col-md-6 d-flex justify-content-xl-end mb-lg-0 mb-3 flex-wrap">
            <div className="align-items-center d-flex me-5 mb-2">
                <div className="me-3"><img src={EmailIcon}/></div>
                <div className="">
                  <div className="fs-18 fw-bold ">Address</div>
                  <div className="fs-13">P.O. Box 726 Niantic, CT 06357</div>
                </div>
                
              </div>
              
              <div className="align-items-center d-flex me-5 mb-2">
                <div className="me-3"><img src={PhoneIcon}/></div>
                <div className="">
                  <div className="fs-18 fw-bold ">Phone</div>
                  <div className="fs-13">(860) 739-4446</div>
                </div>
                
              </div>
              <div className="align-items-center d-flex mb-2">
                <div className="me-3"><img src={EmailIcon}/></div>
                <div className="">
                  <div className="fs-18 fw-bold ">Email</div>
                  <div className="fs-13">info@hesco.com</div>
                </div>
                
              </div>
            </Col>
          </Row>
          
            <Row className="mt-4">
              
                 
              <Formik
                
                enableReinitialize={true}
                initialValues={initialValues}
                onSubmit={handleSubmit}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  errors,
                  touched,
                  setFieldValue,
                  setFieldError,
                  setValues,
                }) => (
                  <Form className="pe-xl-3" noValidate onSubmit={handleSubmit}>
                   
                    <Row>
                      <Col md={7} lg={7}>
                        <Card className="border-0 mb-3 contact-form">
                          <Card.Body className="br-10 p-4 pb-0">
                            
                            <div className="col-xl-12">
                              <Row>
                                <Col md="12">
                                  <h2 className="fs-20 fw-bold ls-2 border-left-6 mb-4 text-uppercase">
                                    GET IN TOUCH WITH US
                                  </h2>
                                </Col>
                              </Row>
                              <Row>
                                    <Col md="12">
                                      <InputText
                                        controlId="job_location_address"
                                        label="Email"
                                        placeholder="Email"
                                        touched={touched.job_location_address}
                                        handleBlur={handleBlur}
                                        handleChange={handleChange}
                                        errorsField={
                                          errors.job_location_address
                                        }
                                        value={values.job_location_address}
                                      />
                                    </Col>
                              </Row>
                              
                              <Row>
                                <Col lg="6">
                                  <InputText
                                        controlId="job_location_city"
                                        label="Name"
                                        placeholder="Name"
                                        touched={touched.job_location_city}
                                        handleBlur={handleBlur}
                                        handleChange={handleChange}
                                        errorsField={errors.job_location_city}
                                        value={values.job_location_city}
                                      />
                                </Col>
                                <Col lg="6">
                                  <InputText
                                    controlId="job_location_zip_code"
                                    label="Subject"
                                    placeholder="Subject"
                                    touched={
                                      touched.job_location_zip_code
                                    }
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={
                                      errors.job_location_zip_code
                                    }
                                    value={values.job_location_zip_code}
                                  />
                                </Col>
                              </Row>
                              <Row>
                                    <Col md="12">
                                      <InputTextArea
                                        controlId="job_location_comment"
                                        label="Description"
                                        placeholder="Description"
                                        touched={touched.job_location_comment}
                                        handleBlur={handleBlur}
                                        handleChange={handleChange}
                                        errorsField={
                                          errors.job_location_comment
                                        }
                                        value={values.job_location_comment}
                                        focused={true}
                                      />
                                   
                                    </Col>
                              </Row>
                            </div>

                            {/*Decal Information*/}
                          </Card.Body>
                        </Card>
                        <Row>
                          <Col sm="12" className="d-flex justify-content-end">
                            <Link
                              to="/app/sites/"
                              className="btn btn-light my-1 fw-semibold me-2"
                            >
                              Cancel
                            </Link>
                            <Button
                              type="submit"
                              variant="primary"
                              className="btn btn-primary my-1 fw-semibold"
                            >
                              Submit
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={5} lg={5}>
                      <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14310.51634253869!2d73.00509399999999!3d26.273698949999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1684316123462!5m2!1sen!2sin" className="contact-map"   loading="lazy" ></iframe>    
                      </Col>
                    </Row>
                   
                  </Form>
                )}
              </Formik>
            
                    
                  
            </Row>
          
        </Container>
      </section>

      
    </>
  );
};
